'use strict';

var _PluginResolver = require('../core/PluginResolver');

var _PluginResolver2 = _interopRequireDefault(_PluginResolver);

var _PluginConfiguration = require('../PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

var _Version = require('../Version');

var _Version2 = _interopRequireDefault(_Version);

var _unit = require('unit.js');

var _unit2 = _interopRequireDefault(_unit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makePlugin(id, version) {
            var plugin = new _PluginConfiguration2.default();
            plugin._id = id;
            plugin._version = new _Version2.default(version);
            plugin._dependencies = [];
            return plugin;
}

// test suite
describe('PluginResolver', function () {
            describe('PluginResolver-simple-dependency', function () {
                        it('should be resolved with empty dependencies', function () {
                                    var plugins = [makePlugin('p1', '1.0')];
                                    var pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p1')).isTrue();
                        });

                        it('should be resolved since constraint is satisfied', function () {
                                    var plugin1 = makePlugin('p1', '1.0');
                                    plugin1._dependencies = [{
                                                "id": "p2",
                                                "version": new _Version2.default('1.2')
                                    }];

                                    var plugin2 = makePlugin('p2', '1.3');

                                    var plugins = [plugin1, plugin2];
                                    var pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p1')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p2')).isTrue();
                        });

                        it('should be resolved failed since version constraint is not satisfied', function () {
                                    var plugin1 = makePlugin('p1', '1.0');
                                    plugin1._dependencies = [{
                                                "id": "p2",
                                                "version": new _Version2.default('1.2')
                                    }];

                                    var plugin2 = makePlugin('p2', '1.1');

                                    var plugins = [plugin1, plugin2];
                                    var pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p1')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p2')).isTrue();
                        });

                        it('should be failed since dependency does not exists', function () {
                                    var plugin1 = new _PluginConfiguration2.default();
                                    plugin1._id = makePlugin('p1', '1.0');
                                    plugin1._dependencies = [{
                                                "id": "p3",
                                                "version": new _Version2.default('1.2')
                                    }];

                                    var plugin2 = makePlugin('p2', '1.1');

                                    var plugins = [plugin1, plugin2];
                                    var pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p1')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('p2')).isTrue();
                        });
            });

            describe('PluginResolver-complex-dependencies', function () {
                        it('should be resolved with cyclic dependencies', function () {
                                    /**
                                     *     ------------>
                                     *     |           |
                                     * a-->b-->c-->d-->e
                                     * |   |    |
                                     * |   g<--  
                                     * f
                                     */
                                    var a = makePlugin('a', '1.0');
                                    a._dependencies = [{
                                                "id": "b",
                                                "version": new _Version2.default('1.0')
                                    }, {
                                                "id": "f",
                                                "version": new _Version2.default('1.0')
                                    }];

                                    var b = makePlugin('b', '1.0');
                                    b._dependencies = [{
                                                "id": "c",
                                                "version": new _Version2.default('1.0')
                                    }, {
                                                "id": "e",
                                                "version": new _Version2.default('1.0')
                                    }];

                                    var c = makePlugin('c', '1.0');
                                    c._dependencies = [{
                                                "id": "d",
                                                "version": new _Version2.default('1.0')
                                    }, {
                                                "id": "g",
                                                "version": new _Version2.default('1.0')
                                    }];

                                    var d = makePlugin('d', '1.0');
                                    d._dependencies = [{
                                                "id": "e",
                                                "version": new _Version2.default('1.0')
                                    }];
                                    var e = makePlugin('e', '1.0');
                                    var f = makePlugin('f', '1.0');
                                    var g = makePlugin('g', '1.0');
                                    g._dependencies = [{
                                                "id": "b",
                                                "version": new _Version2.default('1.0')
                                    }];

                                    var plugins = [a, b, c, d, e, f, g];
                                    var pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('b')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('c')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isTrue();

                                    plugins = [a, b, c, d, e, f, g];
                                    pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('b')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('c')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isTrue();

                                    plugins = [a, b, d, e, f, g];
                                    pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('b')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isFalse();

                                    plugins = [a, c, d, e, f, g];
                                    pluginResolver = new _PluginResolver2.default(plugins);
                                    pluginResolver.resolve();

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('c')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isFalse();

                                    pluginResolver.add(b);
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('b')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('c')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isTrue();

                                    _unit2.default.number(pluginResolver.getDependencies('a').length).is(2);
                                    _unit2.default.number(pluginResolver.getDependencies('b').length).is(2);
                                    _unit2.default.number(pluginResolver.getDependencies('c').length).is(2);
                                    _unit2.default.number(pluginResolver.getDependencies('d').length).is(1);
                                    _unit2.default.number(pluginResolver.getDependencies('e').length).is(0);
                                    _unit2.default.number(pluginResolver.getDependencies('f').length).is(0);
                                    _unit2.default.number(pluginResolver.getDependencies('g').length).is(1);

                                    _unit2.default.number(pluginResolver.getDependencyChain('a').length).is(6);
                                    _unit2.default.number(pluginResolver.getDependencyChain('b').length).is(4);
                                    _unit2.default.number(pluginResolver.getDependencyChain('c').length).is(4);
                                    _unit2.default.number(pluginResolver.getDependencyChain('d').length).is(1);
                                    _unit2.default.number(pluginResolver.getDependencyChain('e').length).is(0);
                                    _unit2.default.number(pluginResolver.getDependencyChain('f').length).is(0);
                                    _unit2.default.number(pluginResolver.getDependencyChain('g').length).is(4);

                                    pluginResolver.remove(b);

                                    _unit2.default.bool(pluginResolver.isResolveSuccess('a')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('c')).isFalse();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('d')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('e')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('f')).isTrue();
                                    _unit2.default.bool(pluginResolver.isResolveSuccess('g')).isFalse();
                        });
            });
});
//# sourceMappingURL=testPluginResolver.js.map